import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import SendPinCode from "../../Components/ForgetPassword/SendPinCode";
import VerifyPinCode from "../../Components/ForgetPassword/VerifyPinCode";
import ResetPassword from "../../Components/ForgetPassword/ResetPassword";
import VaultSecureLogo from "../../Components/GeneralComponents/VaultSecureLogo";

const ForgetPassword = () => {
  const navigate = useNavigate();
  const [formState, setFormState] = useState(0);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    email: "",
    new_password: "",
    confirm_password: "",
    reset_token: "",
  });

  const handleLogin = () => navigate(`/login`);

  const formsData = {
    formData,
    setFormData,
    setErrors,
    errors,
    setFormState,
    handleLogin,
  };

  const getTitle = () => {
    switch (formState) {
      case 1:
        return "Verify OTP";
      case 2:
        return "Reset Password";
      default:
        return "Forgot Password?";
    }
  };

  const getSubtitle = () => {
    switch (formState) {
      case 1:
        return "Enter the 6-digit code we sent to your email.";
      case 2:
        return "Create a new password for your account.";
      default:
        return "Enter your email and we'll send you a verification code.";
    }
  };

  return (
    <div className="login-card">
      {/* Left Panel - Dark Side with Branding */}
      <div className="login-left-panel">
        <div className="login-logo-section">
          <VaultSecureLogo className="logo-icon" color="#137fec" />
          <h1>VaultSecure</h1>
        </div>

        <div className="login-branding">
          <h2>Enterprise-Grade Security for Your Cloud Files.</h2>
          <p>
            Securely manage, encrypt, and integrate your files across all major
            cloud providers with confidence and ease.
          </p>
        </div>

        <div className="login-security-badge">
          <Icon icon="mdi:lock" className="lock-icon" />
          <span>256-bit AES Encryption</span>
        </div>
      </div>

      {/* Right Panel - Form Side */}
      <div className="login-right-panel">
        <div className="login-form-container">
          {/* Mobile Logo - Only visible on small screens */}
          <div className="mobile-logo">
            <VaultSecureLogo className="mobile-logo-icon" color="#137fec" />
          </div>

          <div className="login-header">
            <h1>{getTitle()}</h1>
            <h5>{getSubtitle()}</h5>
          </div>

          {formState === 1 ? (
            <VerifyPinCode {...formsData} />
          ) : formState === 2 ? (
            <ResetPassword {...formsData} />
          ) : (
            <SendPinCode {...formsData} />
          )}

          <hr className="login-border-line" />
          <div className="bottom-content">
            <div className="content-left">
              <div className="security-badge-item">
                <Icon icon="mdi:shield-check" className="badge-icon" />
                <span>HIPAA Compliant</span>
              </div>
            </div>
            <div className="content-right">
              <div className="security-badge-item">
                <Icon icon="mdi:lock-check" className="badge-icon" />
                <span>Enterprise Grade Security</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgetPassword;
